import { Notifications } from 'clipsal-cortex-types/src/api';

import alarmNotifications from '../stubs/alarm-notifications.json';
import chronologicalNotifications from '../stubs/chronological-notifications.json';
import emptyNotifications from '../stubs/empty-notifications.json';
import infoNotifications from '../stubs/info-notifications.json';
import readNotifications from '../stubs/read-notifications.json';
import totalUnreadNotifications from '../stubs/total-unread-notifications.json';
import unreadNotifications from '../stubs/unread-notifications.json';
import warningNotifications from '../stubs/warning-notifications.json';

export const NOTIFICATIONS_ROUTE_MAP = {
  '/v1/notifications?app_name=SE_HOME&limit=0&offset=0&archived=false&read=false&clipsal_solar_id=1':
    totalUnreadNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&read=true&clipsal_solar_id=1':
    readNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&read=false&clipsal_solar_id=1':
    unreadNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&clipsal_solar_id=1':
    chronologicalNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=true&clipsal_solar_id=1':
    emptyNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=true&read=true&clipsal_solar_id=1':
    emptyNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=true&read=false&clipsal_solar_id=1':
    emptyNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=true&severity=ALARM&clipsal_solar_id=1':
    emptyNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=true&severity=WARNING&clipsal_solar_id=1':
    emptyNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=true&severity=INFO&clipsal_solar_id=1':
    emptyNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&severity=ALARM&clipsal_solar_id=1':
    alarmNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&severity=WARNING&clipsal_solar_id=1':
    warningNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&severity=INFO&clipsal_solar_id=1':
    infoNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&read=true&archived=true&clipsal_solar_id=1':
    readNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&read=false&archived=true&clipsal_solar_id=1':
    unreadNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&archived=true&clipsal_solar_id=1':
    chronologicalNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&severity=ALARM&archived=true&clipsal_solar_id=1':
    alarmNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&severity=WARNING&archived=true&clipsal_solar_id=1':
    warningNotifications as Notifications,
  '/v1/notifications?app_name=SE_HOME&limit=10&offset=0&archived=false&severity=INFO&archived=true&clipsal_solar_id=1':
    infoNotifications as Notifications,
};
